import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { isMobile } from './exportFunc';
export default () =>{
    gsap.registerPlugin(ScrollTrigger);
	let OFFSET;

	isMobile()?OFFSET = "top bottom":OFFSET = "top bottom-=150px";
	const DURATION = 1.5;
	const GLOBALDELAY = 3;
    //#region FADE ANIMATION 
		
        function fade(){
            const fadeYElements = document.querySelectorAll('[data-animation-fadeY]');
		    const fadeElements = document.querySelectorAll('[animation-fade]');
            fadeYElements.forEach(el =>{
                const timeLine = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: OFFSET,
                    },
                })
                timeLine.to(el,  {
                    y: 0,
                    ease: "Power1.easeOut",
                    duration: DURATION,
                    delay:0,
                    onStart: ()=>{
                        gsap.to(el,  {
                            opacity: 1,
                            ease: "Power1.easeIn",
                            duration: DURATION/2,
                            delay:0,
                        });
                    }
                });
            })
            fadeElements.forEach(el =>{
                const timeLine = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: OFFSET,
                    },
                })
                timeLine.to(el,  {
                    opacity: 1,
                    ease: "power1.easeIn",
                    duration: DURATION,
                    delay:0.2,
                });
            })
        }
		fade();
        window.fade = fade;
	
	//#endregion

}